import styles from "../products/analytics-table.module.css"

export default function UserInsights({ data }) {
	if (!data) {
		return (
			<div className={styles.tableContainer}>
				<h2>User Insights</h2>
				<p style={{ color: "rgba(255, 255, 255, 0.6)" }}>No insights data available</p>
			</div>
		)
	}

	return (
		<div className={styles.tableContainer}>
			<h2>User Insights</h2>
			<div className={styles.roiCard}>
				<h3>User Retention</h3>
				<p>Retention Rate: {data?.userRetention.retentionRate?.toLocaleString()}%</p>
				<p>Total Active Users: {data?.userRetention.totalActiveUsers?.toLocaleString()}</p>
				<p>Total Users: {data?.userRetention.totalUsers?.toLocaleString()}</p>
			</div>

			<div className={styles.roiCard}>
				<h3>VIP Impact</h3>
				<p>Avg Order Value Increases: {data?.vipImpact.avgOrderValueIncrease?.toLocaleString()}</p>
				<p>Percentage Of Revenue: {data?.vipImpact.percentageOfRevenue?.toLocaleString()}%</p>
			</div>
		</div>



	)
}
